import React from "react";
import IPage from "../../interfaces/page"
import SettingsComponent from "../../components/Settings/Settings.component";

const SettingsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <SettingsComponent></SettingsComponent>;
};

export default SettingsPage;
